"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDigitalNetAnnotationSchema = exports.IAnalogNetAnnotationSchema = exports.SignalAttributeInferenceSourceSchema = void 0;
const zod_1 = require("zod");
const DesignModels_1 = require("../../DesignModels");
const NetAnnotationType_1 = require("../NetAnnotationType");
exports.SignalAttributeInferenceSourceSchema = zod_1.default.object({
    type: zod_1.default.literal('signal-attribute'),
    module: zod_1.default.string(),
    signalId: zod_1.default.string(),
    attribute: DesignModels_1.SignalAttributesSchema.keyof(),
});
exports.IAnalogNetAnnotationSchema = zod_1.default.object({
    net: zod_1.default.string(),
    type: zod_1.default.literal(NetAnnotationType_1.NetAnnotationType.Analog),
    inferenceSources: exports.SignalAttributeInferenceSourceSchema.array(),
});
exports.IDigitalNetAnnotationSchema = zod_1.default.object({
    net: zod_1.default.string(),
    type: zod_1.default.literal(NetAnnotationType_1.NetAnnotationType.Digital),
    inferenceSources: exports.SignalAttributeInferenceSourceSchema.array(),
});
//# sourceMappingURL=NetSignalAnnotationType.js.map